module.exports = (s) => s.toLocaleString("en-US").replace(/\.0+$/, "");
